const topic_category_types = [
  {
    label: "Default",
    value: "default",
  },
  {
    label: "System",
    value: "system",
  },
  {
    label: "Custom",
    value: "custom",
  },
];

export default topic_category_types;
